import { useState } from "react";
import preview from "../../assets/video-preview.png";
import { videoplayer } from "../../data/account/allcourse";
import { BsCheckCircleFill } from "react-icons/bs";
import { IconContext } from "react-icons";
import { AiFillPlayCircle } from "react-icons/ai";
import { HiOutlineArrowNarrowLeft } from "react-icons/hi";
import Vid from "../../assets/video.mp4";
import "../../styles/videoplayer.css";

interface video {
  content: {
    duration: string;
    detail: string;
  };
  i: number;
}

const Videoplayer = () => {
  const [index, setindex] = useState<number>(0);
  const VideoSubContent = ({ content, i }: video) => {
    const [isClicked, setIsClicked] = useState(false);
    return (
      <div>
        <IconContext.Provider value={{ className: "videoplayer-icons" }}>
          <div onClick={() => setindex(i)}>
            <div className="video-check-container">
              <BsCheckCircleFill
                className="video-check"
                style={{ color: "var(--vidomCustomBlue)" }}
              />
            </div>
            <h5>{content.detail}</h5>
          </div>
          {isClicked && (
            <div className="video-quality">
              <ul>
                <li>Auto Play</li>
                <li>1080p</li>
                <li>720p</li>
                <li>432p</li>
                <li>360p</li>
              </ul>
              <p>On</p>
            </div>
          )}

          <div
            className="video-duration"
            onClick={() => setIsClicked(!isClicked)}
          >
            <AiFillPlayCircle
              className="video-play"
              style={{ color: "var(--vidomGray)" }}
            />
            <p>{content.duration}</p>
          </div>
        </IconContext.Provider>
      </div>
    );
  };

  const videoContent = videoplayer.map((content, i) => (
    <div
      key={i}
      className="video-player-content-card"
      style={{ background: index === i ? "rgba(255, 153, 0, 0.1)" : "#FBFBFB" }}
      onClick={() => setindex(i)}
    >
      <VideoSubContent
        content={content}
        i={i}
      />
    </div>
  ));

  return (
    <section className="video-player-cont">
      <div>
        <div className="video-player-header">
          <HiOutlineArrowNarrowLeft
            style={{ fontSize: "2em", color: "#fff", marginRight: "0.5em" }}
          />
          <h3>User Experience (UX): The Ultimate Guide to Usability and UX</h3>
        </div>

        <video
          controls
          poster={preview}
        >
          <source
            src={Vid}
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </div>
      <div className="video-player-content">
        <h4>Course Content</h4>
        <div className="video-card-container">{videoContent}</div>
      </div>
    </section>
  );
};

export default Videoplayer;
